import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// Import Main styles for this application
import './scss/style.css';

import './App.css';
import 'react-dates/lib/css/_datepicker.css'


// Containers
import AuthenticatedRoute from './containers/AuthenticatedRoute';
import ViewSharedRecord from './views/PersonalHealthRecord/ViewSharedRecord'
import Login from './containers/Login';
import { DefaultLayout } from './containers';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure({
  autoClose: 4000,
  draggable: false,
  //etc you get the idea
});


class App extends Component {

  render() {
    console.log(process.env.REACT_APP_APIHOST)


    return (
      <HashRouter>
        <Switch>
          {/* <Route exact path="/forgotpassword" name="Forgot Password" component={ForgotPassword}/> */}
          <Route exact path="/login" name="" component={Login}/>          
          <Route path="/share/:token" name="" component={ViewSharedRecord}/>          
          <AuthenticatedRoute path="/" component={DefaultLayout} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js